var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"target",staticClass:"template"},[_c('portal',{attrs:{"to":"page-toolbar-tabs"}},[_c('Tabs',{key:_vm.tabs.length,staticClass:"template__tabs",attrs:{"items":_vm.tabs}})],1),_c('keep-alive',[_c('router-view',{key:_vm.$route.path,staticClass:"template__view"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }